import { useDeliveryService } from "../../../services/deliveryService"
import { CompleteShipmentItemRow } from "../../types"
import { Emitter, Event } from "../../../../../features/event-emitter"

export const useActions = () => {
    const { completeShipment } = useDeliveryService()

    const completeDelivery = async (
        deliveryId: string,
        itemsData: CompleteShipmentItemRow[],
        deliveryNoteFile?: File
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        await completeShipment(deliveryId, itemsData, deliveryNoteFile)

        Emitter.emit(Event.DB_SUBMIT_DONE, true)
    }

    return {
        completeDelivery
    }
}
